var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldRank2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gold_rank_2_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 22,
    width: 191,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.456 22H5v154h190.456V22z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gold_rank_2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4 25.249c-5.069-5.285-13.863-3.915-17.103 2.639-8.465 17.104-5.833 38.349 8.168 52.959 17.476 18.228 46.206 19.41 65.124 3.028L40.4 25.25z",
    fill: "#FAE185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.578 60.45c-7.03-2.112-13.996 3.4-13.56 10.682 1.14 19.027 13.996 36.206 33.44 42.044 24.257 7.283 49.83-5.787 58.132-29.307l-78.012-23.42z",
    fill: "#F9DD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.647 103.977c-7.117 1.81-10.199 10.11-6.03 16.111 10.902 15.684 30.858 23.771 50.535 18.757 24.549-6.252 39.607-30.589 34.438-54.976L56.248 94.143l-38.594 9.828-.007.006z",
    fill: "#F9D862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.057 25.249c5.068-5.285 13.862-3.915 17.102 2.639 8.465 17.104 5.833 38.349-8.169 52.959-17.475 18.228-46.206 19.41-65.123 3.028l56.19-58.626z",
    fill: "#FAE185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.879 60.45c7.035-2.112 13.995 3.4 13.558 10.682-1.139 19.027-13.995 36.206-33.438 42.044-24.258 7.283-49.831-5.787-58.132-29.307l78.005-23.42h.007z",
    fill: "#F9DD74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.808 103.977c7.118 1.81 10.199 10.11 6.03 16.111-10.902 15.684-30.857 23.771-50.534 18.757-24.549-6.252-39.607-30.589-34.438-54.976l40.341 10.274 38.595 9.828.006.006z",
    fill: "#F9D862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.365 26.958h102.618c6.131 0 11.116 4.945 11.116 11.04v76.008c0 34.214-27.971 61.994-62.422 61.994-34.45 0-62.423-27.78-62.423-61.994V37.998c0-6.088 4.98-11.04 11.117-11.04h-.006z",
    fill: "#F8D451"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M64.923 52.771h71.508c4.277 0 7.744 3.443 7.744 7.691v46.531c0 23.84-19.493 43.2-43.498 43.2s-43.498-19.36-43.498-43.2v-46.53c0-4.249 3.467-7.692 7.744-7.692z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.431 55.285c2.872 0 5.213 2.324 5.213 5.177v46.531c0 22.432-18.379 40.686-40.967 40.686-22.587 0-40.968-18.254-40.968-40.686v-46.53c0-2.854 2.341-5.178 5.214-5.178h71.508zm0-2.514H64.923c-4.277 0-7.744 3.443-7.744 7.691v46.531c0 23.859 19.474 43.2 43.498 43.2 24.024 0 43.498-19.341 43.498-43.2v-46.53c0-4.249-3.467-7.692-7.744-7.692z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.25 26.958l-32.995 32.77v48.635l81.96-81.405H71.25zM95.755 94.928l64.611-64.168a11.106 11.106 0 00-8.377-3.802h-15.545L81.88 81.148l13.875 13.78z",
    fill: "#fff",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRank2);
export default ForwardRef;